import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyComponentRender from "../../components/EmptyComponentRender";
import firebase from 'firebase';
import OfferCard from '../../components/offers/OfferCard';
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from "@mui/styles/";
import { useTheme } from '@mui/material/styles';
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";

const useStyles = makeStyles({
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
       // marginTop: 20,
        marginLeft: 20,
        marginRight: 20,
      },
      mainContainer: {
        padding: 20,
        /// paddingTop: StatusBar.currentHeight
      },

});

const OffersScreen = () => {
    const [loading, setLoading] = React.useState(false);
    const [offers, setOffers] = React.useState([]);
    const [searchMode, setSearchMode] = React.useState(false);
  const history = useHistory();
  const styles = useStyles();

    const { t } = useTranslation();
    const handleBack = () => {
        history.push("/home");
    }

    useEffect(() => {
        loadOffers();
    }, []);

    const loadOffers = async () => {
        setLoading(true);
        const results = await firebase.firestore().collection('offers').where('isExpired', '!=', true).get();
        const rowData = results.docs.map(r => r.data());
        setOffers(rowData);
        setLoading(false);
    }

    return (
        <div style={{ flex: 1, backgroundColor: '#fff' }}>
        <div className={styles.mainContainer}>
          <div className={styles.content}>
          <Typography style={{ color: "rgb(119, 78, 30)", fontSize: "35px", textAlign: "center", marginBottom: "30px", fontWeight: "bold" }}>{t("screens.offers")}</Typography>
          { !loading && offers.length > 0  ? (        
          <Grid container spacing={4} style={{ display: "flex", flexWrap: "wrap", padding:20}}>
                    {
                        !loading && offers.length > 0 && offers.map((offer, index) => <OfferCard key={'offer card ' + index} offer={offer} />)
                    }
            </Grid>
             ): (
                <EmptyComponentRender />
              )}
        </div>
        </div>
        </div>
    )
}

export default OffersScreen;